import React from 'react';
import { ReviewBladeInfoProps } from '../type';
import logoInfo from '../../assets/review/info.svg';
import backgroundImageBladeInfo from '../../assets/review/background_blade_info.png';

const ReviewBladeInfo: React.FC<ReviewBladeInfoProps> = ({ isLoading }) => {
    if (isLoading) {
        return null;
    }

    return (
        <>
            <div
                className="flex flex-col gap-2 p-6 rounded-[var(--border-radius)] shadow-[0_7px_9px_rgba(141,141,141,0.10),0_4px_13px_rgba(141,141,141,0.08)]"
                style={{
                    backgroundImage: `
                      linear-gradient(270deg, rgba(255, 255, 255, 0) 16.5%, #FFF 46.44%),
                      url(${backgroundImageBladeInfo}),
                      linear-gradient(275deg, #62AA47 4.22%, var(--primary-color, #BED000) 96.79%)
                    `,
                    backgroundPosition: 'center, 50%, center',
                    backgroundSize: 'auto, cover, auto',
                    backgroundRepeat: 'no-repeat, no-repeat, no-repeat',
                    backgroundAttachment: 'scroll, scroll, scroll',
                    backgroundOrigin: 'padding-box, padding-box, padding-box',
                    backgroundClip: 'border-box, border-box, border-box',
                }}
            >
                <div className="flex gap-[10px]">
                    <img
                        className="flex p-[6px] justify-center items-center w-[38px] -ml-2.5 h-auto rounded-[6px] bg-[#D0E6C8]"
                        src={logoInfo}
                        alt="logo info"
                    />
                    <h1 className="text-dark-gray text-[24px] font-bold leading-[120%] p-0 not-italic">
                        Boostez votre notoriété avec des avis clients !
                    </h1>
                </div>
                <p className="text-dark-gray text-small font-medium leading-[120%]">
                    Plus d’avis, plus de visibilité, plus de clients !
                </p>
                <p className="text-dark-gray text-subtle font-normal leading-[120%]">
                    Demandez dès aujourd’hui à vos clients satisfaits, de partager leur expérience
                    sur Google ou Facebook.
                </p>
            </div>
        </>
    );
};

export default ReviewBladeInfo;
